import NestPairCard from './NestPairCard';

export default function HeaderBociany() {
    return (
        <div className="mb-10 flex flex-col items-stretch gap-6 md:flex-row md:items-center md:justify-between">
            <div className="min-w-0">
                <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 text-left">
                    Bociany <span className="text-red-600">Żywocice</span>
                </h1>
                <div className="mt-2 flex flex-col gap-1 text-left text-xs sm:flex-row sm:flex-wrap sm:items-center sm:gap-2 sm:text-sm text-gray-500 font-medium max-w-full">
                    <span className="flex items-center gap-2 shrink-0">
                        <span className="leading-snug">Transmisja na żywo</span>
                    </span>
                    <span className="pl-4 sm:pl-0 leading-snug break-words min-w-0">
                        <span className="hidden sm:inline text-gray-400" aria-hidden>
                            •{' '}
                        </span>
                        Gniazdo przy ul. Łąkowej 2
                    </span>
                </div>
            </div>
            <NestPairCard />
        </div>
    );
}
